export const About = ({ data }) => (
<section id="about" className="section section--about-v7" aria-labelledby="about-title">
 <div className="about-word-v7" aria-hidden="true">IRUN</div>
 <div className="site-container about-layout-v7">
  <div className="about-image-v7" data-motion><img src="/img/about.jpg" alt="IRUN 브랜드 이미지"/><span>10+<small>YEARS</small></span></div>
  <div className="about-copy-v7" data-motion><p className="eyebrow">ABOUT IRUN</p><h2 id="about-title">기술보다 먼저<br/><span>문제를 이해합니다.</span></h2><p className="about-lead-v7">{data?.lead}</p><p>{data?.paragraph}</p><div className="career-v7">{data?.timeline?.map((x,i)=><span key={x}><i>0{i+1}</i><b>{x}</b></span>)}</div></div>
 </div>
</section>);
